import type { FormAnalyticsAggregateResponse } from '@gofranz/formshive-common';
import { Card, Divider, Group, Skeleton, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface TopCountriesListProps {
  aggregate: FormAnalyticsAggregateResponse | null;
  loading: boolean;
}

export function TopCountriesList({ aggregate, loading }: TopCountriesListProps) {
  const { t } = useTranslation();

  const items = (aggregate?.top_countries ?? []).slice(0, 5);
  const total = (aggregate?.top_countries ?? []).reduce((sum, c) => sum + c.count, 0);

  return (
    <Card withBorder padding="md" radius="md" h="100%">
      <Text fw={600} mb="sm">
        {t('messages.topCountriesTitle')}
      </Text>
      <Divider mb="sm" />
      {loading ? (
        <Stack gap="xs">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} h={20} />
          ))}
        </Stack>
      ) : items.length === 0 ? (
        <Text c="dimmed" size="sm">
          {t('messages.topCountriesEmpty')}
        </Text>
      ) : (
        <Stack gap="xs">
          {items.map((item) => {
            const pct = total > 0 ? (item.count / total) * 100 : 0;
            return (
              <Group key={item.country} justify="space-between" wrap="nowrap">
                <Text size="sm" truncate>
                  {item.country}
                </Text>
                <Text size="sm" c="dimmed" fw={500}>
                  {pct.toFixed(1)}%
                </Text>
              </Group>
            );
          })}
        </Stack>
      )}
    </Card>
  );
}
